import React from 'react';

const LoadingSpinner = () => {
  return (
    <div
      className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"
      role="status"
    ></div>
  );
};

export default LoadingSpinner;
